import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFire, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import streakAnimation from "../../../../assets/lottie/streak-fire.json";
import useCountUp from "../../../../hooks/useCountUp";
import FadeIn from "./FadeIn";
import LottieView from "./LottieView";

/**
 * Shown after the lesson-complete screen when today's streak just increased
 * (first lesson of the day).
 * Props:
 * - streak: the new streak length in days
 * - onContinue: called when the learner presses the continue button
 */
const StreakComplete = ({streak = 1, onContinue}) => {
    const animatedStreak = useCountUp(streak, 1000, 600);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-orange-50 via-white to-white px-6 py-10">
            {/* Flame animation keeps looping */}
            <LottieView
                animationData={streakAnimation}
                loop
                className="h-56 w-56 sm:h-72 sm:w-72"
            />

            <FadeIn delay={200} className="text-center">
                <div className="flex items-center justify-center gap-3 text-orange-500">
                    <FontAwesomeIcon icon={faFire} className="text-5xl"/>
                    <span className="text-7xl font-extrabold">
                        {animatedStreak.toLocaleString("fa-IR")}
                    </span>
                </div>

                <h2 className="mt-3 text-4xl font-extrabold text-gray-900 sm:text-5xl">
                    روز پیاپی!
                </h2>

                <p className="mt-3 text-lg text-gray-500">
                    هر روز یک درس؛ زنجیره‌ات را نشکن.
                </p>
            </FadeIn>

            <FadeIn delay={900} className="mt-10 w-full max-w-md">
                <button
                    type="button"
                    onClick={onContinue}
                    className="flex w-full items-center justify-center gap-2 rounded-2xl bg-orange-500 py-4 text-lg font-bold text-white shadow-lg transition hover:bg-orange-400 active:scale-95"
                >
                    ادامه
                    <FontAwesomeIcon icon={faArrowLeft}/>
                </button>
            </FadeIn>
        </div>
    );
};

export default StreakComplete;